import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from '@astek/utils';
import {GenderEnum} from '../services/state/gender.enum';

@Pipe({
  name: 'xpGenderKey',
})
export class GenderKeyPipe implements PipeTransform {

  constructor() {
  }

  public transform(value: GenderEnum | string | null | undefined): string {
    if (
      Utils.isNullOrUndefined(value)
      || (Utils.isString(value) && !Utils.enumValueExists(value, GenderEnum))
    ) {
      return 'SHARED.EMPTY_VALUE';
    }
    return 'SHARED.GENDER.' + Utils.enumName(value, GenderEnum);
  }

}
